<template>
  <div
    class="text-gray-600 pb-24"
    :style="{ '--campaign-color': campaignColor }"
  >
    <SignUpLayoutBox>
      <TwoForOneHero
        :is-two-for-one-campaign="isTwoForOneCampaign"
        :is-last-chance-two-for-one-campaign="isLastChanceTwoForOneCampaign"
        :locale="locale"
        :country="country"
      />
    </SignUpLayoutBox>
    <div
      v-if="isFeaturedBoxersCampaign"
      class="container no-padding-container"
    >
      <div class="px-10 pt-14 md:pt-20">
        <FeaturedBoxers />
      </div>
    </div>
    <div
      v-if="isNewCountry"
      class="pt-12 lg:pb-12 lg:pt-32"
    >
      <CountryOpening
        :country="country"
        :locale="locale"
        :is-two-for-one-campaign="isTwoForOneCampaign"
        @click="$router.push($i18n.localePath({ name: 'men-signup' }))"
      />
    </div>
    <WhyOta
      :class="{'lg:pt-56': isTwoForOneCampaign, 'lg:pt-32': !isTwoForOneCampaign}"
      :is-two-for-one-campaign="isTwoForOneCampaign"
      :button-text="isTwoForOneCampaign ? $t('TwoForOneCampaign.TryForFree') : $t('TryItNow.IWantThis')"
      :country="country"
      :locale="locale"
      @click="$router.push($i18n.localePath({ name: 'men-signup' }))"
    />
    <div v-if="showLoyaltyProgram" class="mt-12 md:mt-24 md:mb-12">
      <LoyaltyBlock :country="country" :locale="locale" />
    </div>
    <div class="container no-padding-container max-w-full">
      <InstagramWidget class="pt-12" />
    </div>
    <div class="pt-16 md:pt-24">
      <PhotoTextSection :image="images[0]">
        <div class="p-10 h-full flex flex-col justify-center">
          <div>
            <h4 class="ota-h2-medium mb-2" v-html="$t('TryItNow.MoreUSPS[0].Title')" />
            <p class="ota-p14 mb-12" v-html="$t('TryItNow.MoreUSPS[0].Description')" />
            <h4 class="ota-h2-medium mb-2" v-html="$t('TryItNow.MoreUSPS[1].Title')" />
            <p class="ota-p14" v-html="$t('TryItNow.MoreUSPS[1].Description')" />
          </div>
        </div>
      </PhotoTextSection>
      <PhotoTextSection
        :image="images[1]"
        is-reversed
        class="md:mt-12"
      >
        <div class="p-10 h-full flex flex-col justify-center">
          <div class="md:text-right">
            <h4 class="ota-h2-medium mb-2" v-html="$t('TryItNow.MoreUSPS[2].Title')" />
            <p class="ota-p14 mb-12" v-html="$t('TryItNow.MoreUSPS[2].Description')" />
            <h4 class="ota-h2-medium mb-2" v-html="$t('TryItNow.MoreUSPS[3].Title')" />
            <p class="ota-p14" v-html="$t('TryItNow.MoreUSPS[3].Description')" />
          </div>
        </div>
      </PhotoTextSection>
    </div>
    <div class="container no-padding-container">
      <StarRating
        v-if="rating"
        class="mt-16 pb-10 pt-20 md:pb-20"
        :title="'TryItNow.ReviewsTitle'"
        :rating="rating"
        :reviews="ratingTotal"
        @click="onRatingClick"
      />
      <div class="bg-neutral-50">
        <div class="container no-padding-container">
          <Reviews title="" :class="{ 'pt-10 md:pt-20': !rating }" />
          <p class="o-body text-center py-5" v-text="$t('HomePage.SelectedFavoriteReviews')" />
        </div>
      </div>
    </div>
    <TwoForOneCampaign
      v-if="isTwoForOneCampaign"
      class="py-20 md:py-24"
      :title="$t('TwoForOneCampaign.Title')"
      :link="$t('TwoForOneCampaign.TermsLink')"
      @signup="redirectToSignup"
    />
    <div class="container no-padding-container md:flex md:mt-24">
      <div class="bg-gray-50 py-12 px-10 mt-12 relative md:mt-0 md:flex md:pr-0 md:py-0 md:flex-1">
        <div class="model-image-side md:py-5">
          <OImage
            :desktop="floydModelImage.desktop"
            :mobile="floydModelImage.mobile"
            :fallback="floydModelImage.fallback"
            img-class="top-0 absolute left-0 max-h-full md:relative"
            :alt="$t('Accessibilty.AltTags.ProductImage')"
          />
        </div>
        <div class="pl-28 relative pr-4 md:pl-0 md:pt-12">
          <h4 class="ota-h2" v-text="$t('TryItNow.WhatYouGet.Title')" />
          <p class="ota-p16 font-semibold text-gray-300 mb-5 mt-2" v-text="$t('TryItNow.WhatYouGet.Monthly', { price: boxerPrice })" />
          <USPs class="what-you-get-usps" :usps="usps" />
        </div>
      </div>
      <div class="md:ml-4">
        <OImage
          :desktop="furyDetailImage.desktop"
          :mobile="furyDetailImage.mobile"
          :fallback="furyDetailImage.fallback"
          img-class="w-full h-full object-cover md:rounded"
          :alt="$t('Accessibilty.AltTags.ProductImage')"
        />
      </div>
    </div>
    <div class="mt-12 md:mt-24 faq-container px-10">
      <Faq :items="faqItems" />
    </div>
  </div>
</template>

<script>
import OImage from '@/components/OImage'
import InstagramWidget from '@/components/InstagramWidget'
import USPs from '@/components/USPs'
import PhotoTextSection from '@/components/PhotoTextSection'
import SignUpLayoutBox from '@/components/SignUpLayoutBox'
import LoyaltyBlock from '@/components/LoyaltyBlock'
import Reviews from '@/components/Reviews'
import FeaturedBoxers from '@/components/FeaturedBoxers'
import TwoForOneCampaign from '@/components/TwoForOneCampaign/index'
import Faq from '@/components/Faq'
import {
  getImagePaths,
  addLocalCurrency,
  convertSrc,
  showLoyaltyProgram,
  isFeaturedBoxersCampaign,
  isNewCountry, getEuros
} from '@/utils/general'
import { MenPrices } from '@/enums/products'
import { Currencies } from '@/enums/general'
import { CancelDays, DeliveryDates, DeliveryTimeInDays } from '@/enums/shipments'
import { PaymentDates } from '@/enums/payments'
import { MaxCancelDates } from '@/enums/member'
import { GET_GOOGLE_RATING, GET_FLAGS } from '@/utils/store/actionTypes'
import { mapActions, mapGetters, mapState } from 'vuex'
import StarRating from '@/components/StarRating'
import CountryOpening from '@/components/CountryOpening'
import TwoForOneHero from '@/components/TwoForOneHero'
import WhyOta from '@/components/WhyOta'
import { ActiveCampaign } from '@/enums/campaigns'
import { IS_FLAGS_FETCHED, IS_TWO_FOR_ONE_CAMPAIGN, IS_TWO_FOR_ONE_CAMPAIGN_LAST_DAY } from '@/utils/store/getterTypes'

export default {
  name: 'TryItNow',
  layout: 'homepage-signup-button',
  components: {
    Faq,
    WhyOta,
    InstagramWidget,
    USPs,
    OImage,
    SignUpLayoutBox,
    PhotoTextSection,
    LoyaltyBlock,
    Reviews,
    TwoForOneCampaign,
    StarRating,
    FeaturedBoxers,
    CountryOpening,
    TwoForOneHero
  },
  async fetch () {
    await Promise.all([
      this.getAndSetGoogleRating(),
      this.getAndSetFlags()
    ])
  },
  data () {
    return {
      rating: null,
      ratingTotal: null
    }
  },
  computed: {
    title () {
      if (this.isTwoForOneCampaign) {
        if (this.isLastChanceTwoForOneCampaign) {
          return this.$t(`TryItNow.Campaigns.${ActiveCampaign.name}.LastChance.Title`, { ...this.variables })
        }

        return this.$t(`TryItNow.Campaigns.${ActiveCampaign.name}.Title`, { ...this.variables })
      }

      return this.$t('TryItNow.AlwaysThePerfectBoxershortBR', { ...this.variables })
    },
    subTitle () {
      if (this.isTwoForOneCampaign) {
        if (this.isLastChanceTwoForOneCampaign) {
          return this.$t(`TryItNow.Campaigns.${ActiveCampaign.name}.LastChance.SubTitle`, { ...this.variables })
        }

        return this.$t(`TryItNow.Campaigns.${ActiveCampaign.name}.SubTitle`, { ...this.variables })
      }

      return this.$t('TryItNow.MonthlyBoxershorts', { ...this.variables })
    },
    banner () {
      if (this.isLastChanceTwoForOneCampaign) {
        return getImagePaths({ path: `${ActiveCampaign.s3Path}/banner-last-${this.locale}`, s3: true })
      }

      return getImagePaths({ path: `${ActiveCampaign.s3Path}/banner-${this.locale}`, s3: true })
    },
    variables () {
      return {
        country: this.$t(`Countries.${this.country}`),
        price: addLocalCurrency(MenPrices[this.country], this.country, Currencies[this.country]).replace(/\s/g, ''),
        pricex2: addLocalCurrency(MenPrices[this.country] * 2, this.country, Currencies[this.country]).replace(/\s/g, ''),
        loyaltyPoints: getEuros(this.country, 10)
      }
    },
    gif () {
      return getImagePaths({ path: 'img/try-now' })
    },
    campaignColor () {
      return ActiveCampaign.color
    },
    isNewCountry () {
      return isNewCountry(this.country)
    },
    showLoyaltyProgram () {
      return showLoyaltyProgram(this.country)
    },
    tryNowUsps () {
      const items = this.$t('TryItNow.USPS')

      if (!Array.isArray(items)) {
        return []
      }

      return items.map((_, index) => this.$t(`TryItNow.USPS[${index}]`, { ...this.variables }))
    },
    usps () {
      const usps = this.$t('TryItNow.WhatYouGet.USPS')

      if (this.isTwoForOneCampaign) {
        usps.splice(0, 1)
      }

      return usps
    },
    isFeaturedBoxersCampaign () {
      return isFeaturedBoxersCampaign(this.country)
    },
    faqItems () {
      const items = this.$t('TryItNow.FAQ')

      if (!Array.isArray(items)) {
        return []
      }

      return items.map((_, index) => ({
        title: this.$t(`TryItNow.FAQ[${index}].Question`),
        description: this.$t(`TryItNow.FAQ[${index}].Answer`, {
          firstDeliveryDate: DeliveryDates[this.country].firstDeliveryDate,
          lastDeliveryDate: DeliveryDates[this.country].lastDeliveryDate,
          paymentDate: PaymentDates[this.country],
          waitingDays: CancelDays[this.country].waitingDays,
          daysToCancel: CancelDays[this.country].daysToCancel - CancelDays[this.country].waitingDays,
          maxCancelDate: MaxCancelDates[this.country],
          deliveryDays: DeliveryTimeInDays[this.country]
        })
      }))
    },
    boxerPrice () {
      return addLocalCurrency(MenPrices[this.country], `${this.locale}-${this.country}`, Currencies[this.country]).replace(/\s/g, '')
    },
    images () {
      return {
        0: getImagePaths({ path: '/images/frontend/try-now/snap-waistband', extension: '.webp', s3: true }),
        1: getImagePaths({ path: '/images/frontend/try-now/snap-commercial', extension: '.webp', s3: true })
      }
    },
    floydModelImage () {
      return getImagePaths({
        path: '/images/frontend/try-now/floyd-model',
        extension: '.webp',
        s3: true
      })
    },
    furyDetailImage () {
      return getImagePaths({
        path: '/images/frontend/try-now/fury-detail',
        extension: '.webp',
        s3: true
      })
    },
    heroVideo () {
      if (this.isFeaturedBoxersCampaign) {
        return convertSrc('/images/frontend/try-now/halloween23/halloween_video_header.mp4', true)
      }

      if (this.isTwoForOneCampaign) {
        return convertSrc(`/images/frontend/try-now/video/video-header-${encodeURIComponent('1+1')}-campaign-${this.locale}.mp4`, true)
      }

      return convertSrc(`/images/frontend/try-now/video-header-${this.locale}.mp4`, true)
    },
    ...mapState('app', {
      country: state => state.country,
      locale: state => state.locale
    }),
    ...mapGetters('flags', {
      isFlagsFetched: IS_FLAGS_FETCHED,
      isTwoForOneCampaign: IS_TWO_FOR_ONE_CAMPAIGN,
      isLastChanceTwoForOneCampaign: IS_TWO_FOR_ONE_CAMPAIGN_LAST_DAY
    })
  },
  methods: {
    onRatingClick () {
      window.open(this.$t('HomePage.GoogleReviewPage'), '_blank', 'noopener')
    },
    onEnded () {
      if (this.$refs.video) {
        this.$refs.video.load()
      }
    },
    redirectToSignup () {
      this.$router.push(this.$i18n.localePath({ name: 'men-signup' }))
    },
    async getAndSetGoogleRating () {
      try {
        const { rating, ratingTotal } = await this.getGoogleRating()

        this.rating = rating
        this.ratingTotal = ratingTotal
      } catch (error) {
        this.$ota.general.logError(error)
      }
    },
    async getAndSetFlags () {
      if (this.isFlagsFetched) {
        return
      }

      try {
        await this.getFlags()
      } catch (error) {
        this.$ota.general.logError(error)
      }
    },
    ...mapActions('homepage', {
      getGoogleRating: GET_GOOGLE_RATING
    }),
    ...mapActions('flags', {
      getFlags: GET_FLAGS
    })
  },
  head () {
    return {
      script: [
        { src: 'https://justreview.co/widget/justreview.js' }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped>
>>> .osignup-box-container {
  video::-internal-media-controls-overlay-cast-button {
    display: none;
  }

  & > div {
    @apply overflow-visible;
  }

  .ota-h1 span {
    color: var(--campaign-color);
  }

  .ota-h1 b {
    @apply text-turquoise-300;
  }

  .obutton {
    @apply px-4 !important;
  }

  .ota-usps {
    &-container {
      @apply bg-white px-0;

      svg {
        @apply fill-gray-600 w-4 h-4;
      }
    }
  }
}

.faq-container {
  @apply mx-auto;
  max-width: 54rem;
}

.oimage >>> .object-cover {
  @apply object-cover !important;
}

.no-padding-container {
  @apply px-0 !important;
}

.oimage >>> img {
  max-width: 100% !important;
}

>>> .oimage img {
  max-width: 100% !important;
}

.what-you-get-usps {
  @apply px-0 !important;

  >>> .ota-usps-container {
    @apply p-0;

    svg {
      @apply w-4 h-4 fill-turquoise-300;
    }

    &-grid {
      @apply block;
      max-width: 32rem;
    }
  }
}

.max-container-width {
  max-width: 91rem;
}

>>> .osignup-box-container {
  .max-usps-w {
    .ota-usps-container-grid > .flex {
      .text-sm {
        font-size: 1.6rem;
      }
    }

    .ota-usps-container-grid > .flex.mb-2 {
      @apply mb-4;
    }

    .ota-usps-container-grid {
        @apply block;
      }
  }
}

@screen md {
  .gif-video {
    max-width: 36.5rem;
  }

  .boxer-max-width {
    width: 157rem;

    >>> img {
      max-width: 100% !important;
    }
  }

  .model-image-side {
    min-width: 40%;
  }
}

@screen lg {
  >>> .osignup-box-container {
    .ota-usps {
      @apply px-0;
    }

    .max-usps-w {
      max-width: 41rem;
    }
  }
}
</style>
